<template>
    <div>
        <v-navigation-drawer
        v-model="drawer"
        app
        clipped
        :dark="customization.leftMenuDark"
        :color="customization.leftMenuColor"
        >
            <v-img :src="customization.logo"></v-img>
            <v-list-group >
                <template v-slot:activator>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="title">{{ usuario.displayName }}</v-list-item-title>
                            <v-list-item-subtitle>{{ usuario.login }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <v-list-item dense style="padding-top: 5px; padding-bottom: 5px">
                    <v-list-item-title><b>Versão do Aplicativo:</b> {{version}}</v-list-item-title>
                </v-list-item>
                <v-list-item 
                link router
                @click="logout">
                    <v-list-item-title>Sair</v-list-item-title>
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list-group>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-group
                    v-for="(item,i) in items"
                    :key="item.text + '_' + i"
                    :prepend-icon="item.icon"
                    :value="false"
                >
                    <template v-slot:activator>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </template>
                    <v-list-item
                        v-for="(sitem, i) in item.items.filter(v=>(v.items.length <= 0))"
                        :key="i"
                        link
                        router
                        :to="sitem.link"
                    >
                        <v-list-item-title>{{sitem.text}}</v-list-item-title>
                        <v-list-item-icon>
                            <v-icon>{{sitem.icon}}</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-list dense>
                        <v-list-group
                            v-for="(item2,i) in item.items.filter(v=>(v.items.length > 0))"
                            :key="item2.text + '_' + i"
                            :prepend-icon="item2.icon"
                        >
                            <template v-slot:activator>
                                <v-list-item-title>{{ item2.text }}</v-list-item-title>
                            </template>
                            <v-list-item
                                v-for="(sitem, i) in item2.items"
                                :key="i"
                                link
                                router
                                :to="sitem.link"
                            >
                                <v-list-item-title>{{sitem.text}}</v-list-item-title>
                                <v-list-item-icon>
                                    <v-icon>{{sitem.icon}}</v-icon>
                                </v-list-item-icon>
                            </v-list-item>
                        </v-list-group>
                    </v-list>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar
            app
            clipped-left
            :dark="customization.topBarDark"
            :color="customization.topBarColor"
            height="65px"
        >
            <v-app-bar-nav-icon @click="drawer = !drawer" :style="`color: ${customization.mainBtnColor}`">
                <v-icon>{{drawer ? "mdi-menu-open" : "mdi-menu"}}</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title><img :src="customization.logo" style="height: 45px; transform: translate(-10px, 5px)" /></v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon v-if="['View','Edit','Create'].includes(router.name)" @click="back" :style="`color: ${customization.mainBtnColor}`">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

        </v-app-bar>
    </div>
</template>

<script>
import router from '@/router/index.js';

export default {
    name: 'Navbar',
    data: () => ({
        drawer: window.innerWidth > 900,
        items: [],
        singleItems: [{
            icon: `mdi-view-dashboard`, 
            text: `Dashboard`, 
            link: `/dashboard`
        }],
        usuario: {},
        customization: {},
        router: {},
        version: null
    }),
    methods: {
        logout(){
            localStorage.removeItem("usrId");
            router.push("/");   
        },
        back(){
            router.push(`/CRUD/${this.router.params.nameType}`);
        },
        menu(){
            const menu = JSON.parse(localStorage.getItem("menu"));
            
            const modulos = [
                {
                    "nome": "Módulo Transportes",
                    "items":[
                        "002",
                        "1005",
                        "010",
                        "1054",
                        "1061",
                        "1050",
                        "1051",
                        "1052",
                        "1053",
                        "1056",
                        "013",
                        "1062",
                        "203",
                        "204",
                        "205"
                    ]
                },
                {
                    "nome": "Módulo Obra Civil",
                    "items":[
                        "002",
                        "1201",
                        "1202",
                        "1203",
                        "1204",
                        "1205",
                        "1206",
                        "1150",
                        "1207"
                    ]
                }
            ]

            let all_items = [];
            
            modulos.forEach((m,index)=>{
                all_items[index] = {
                    text: m.nome,
                    items: []
                };
                let items = all_items[index].items;
                items.push({
                    icon: `mdi-view-dashboard`, 
                    text: `Dashboard`, 
                    link: `/dashboard${index == 0 ? "" : "_"+index}`,
                    items: [],
                    id: "000"
                });
                menu.forEach(i=>{
                    if(m.items.includes(i.idacao)){
                        const parent = items.map(it=>it.id).indexOf(i.parentID);
                        
                        if(parent >= 0)
                            items[parent].items.push({
                                icon: `mdi-${i.iconevue}`, 
                                text: `${i.caption}`, 
                                link: `/${i.formVue}`
                            });
                        else
                            items.push({
                                icon: `mdi-${i.iconevue}`, 
                                text: `${i.caption}`, 
                                link: `/${i.formVue}`,
                                items: [],
                                id: i.idacao
                            });
                    }
                })
                items = items.sort((a, b)=>{return a.items.length-b.items.length});
            })
            this.items = all_items;
        }
    },
    mounted(){
        this.router = this.$route;

        this.customization = JSON.parse(localStorage.getItem("customization"));
        
        this.usuario = {
            nome: localStorage.getItem("nome"),
            login: localStorage.getItem("login")
        };
        this.usuario.displayName = this.usuario.nome.length <= 16 ? this.usuario.nome : this.usuario.nome.substring(0,16) + "...";
        
        document.getElementById("app").style.backgroundColor = this.customization.backgroundColor;
        document.body.style.backgroundColor = this.customization.backgroundColor;
        
        this.version = window.mainApp.version;

        if(JSON.parse(localStorage.getItem("menu")) == null)
            setTimeout(() => {
                this.menu();
            }, 1000);
        else this.menu();
          
    }
}
</script>